import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device_batch",
  "use": "device_batch-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device_batch\"><path d=\"M2.5 4.5h11v7h-11v-7zM2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2zm3 3h6v1.5H5V6zm4 3H5v1.5h4V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol